import {Modalator} from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class CreateAddressItem extends HTMLDivElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorAddAddress() {
        return ".add-address";
    }

    initCreateAddressesModal( link, container, loadedCallback ) {
        var url = link.dataset.href;

        var modal = new Modalator();

        modal.initRemoteModal('#modal-create-address', url, loadedCallback, function( data ) {
            container.updateCartViews( data );
        });
    }

    initEvents() {
        this.querySelector(this.getSelectorAddAddress()).addEventListener('click',  (e) => {
            e.preventDefault();

            this.initCreateAddressesModal(e.target, this.mainContainer);
        });
    }
};

